export interface AnalysisConfigurationGq {
  id: number;
  createTime: string;
  projectId: number;
  title: string;
  analysisFilter: string;
  chartId: string;
  order: number;
}

export const AnalysisConfigurationGqProps = `
    id
    createTime
    projectId
    title
    analysisFilter
    chartId
    order
`;
